export class MailTemplate {
    public id: string;
    public title: string;
    public header: string;
    public footer: string;
}



// WEBPACK FOOTER //
// ./src/classes/mailTemplate.ts